import { Metamodel } from 'app/model/base/model';
import { Named } from 'app/model/base/named';
import { IModel } from 'app/model/base/annotation';

@Metamodel.model({
    abstract: true
})

export abstract class CompressionReadSettings extends Named {
    public static readonly MODEL: IModel;
}
